/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import Text from 'components/Text';
import { WHITE } from 'styles/colors';
import PartyFeek from 'assets/images/PartyFeek.png';
import LandingBussinessHeroBg from 'assets/images/LandingBussinessHeroBg.png';

const styles = css`
  background: url(${LandingBussinessHeroBg});

  .plan-image {
    width: 100%;
    right: 0;
  }

  .plan-content {
    padding: 0px;
    right: 0;
    left: 0;
    background: url(${PartyFeek});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }

  .plan-info {
    max-width: 100%;
    display: flex;
    padding: 100px 100px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }
  .plan-info-title {
    color: var(--ui-20-light-purple, #efeeff);
    leading-trim: both;
    text-edge: cap;
    font-family: Roobert;
    font-style: normal;
    font-weight: 600;
    line-height: 120%; /* 64.8px */
  }
  .plan-info-text {
    color: var(--ui-20-purple-medium, #c5bcfe);
    leading-trim: both;
    text-edge: cap;
    font-family: Roobert;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
  }
  .row-plan-info {
    margin-right: 0px;
    margin-left: 0px;
  }

  /* Responsive Design */
  @media (max-width: 1200px) {
    .plan-feek {
      padding: 50px 15px;
      min-height: 450px;
    }

    .plan-content {
      height: 350px;
    }

    .plan-feek-text {
      font-size: 42px;
    }

    .plan-feek-image {
      max-width: 450px;
    }

    .plan-info {
      padding: 30px 30px;
    }
  }

  @media (max-width: 992px) {
    .plan-feek {
      padding: 40px 10px;
      min-height: 400px;
    }
    .plan-content {
      height: 300px;
    }
    .plan-feek-text {
      font-size: 36px;
    }
    .plan-info {
      padding: 30px 30px;
    }

    .plan-feek-image {
      max-width: 400px;
    }
  }

  @media (max-width: 768px) {
    .plan-feek {
      padding: 30px 5px;
      min-height: 350px;
      text-align: center;
    }
    .plan-content {
      height: 250px;
    }
    .plan-info {
      padding: 30px 30px;
      text-align: center;
    }
    .plan-feek-text {
      font-size: 28px;
      margin-bottom: 30px;
    }

    .plan-info-text {
      text-align: center;
    }
    .plan-info-title {
      text-align: center;
      padding-top: 30px;
    }
    .plan-feek-image {
      max-width: 300px;
    }
  }

  @media (max-width: 576px) {
    .plan-feek {
      padding: 20px 5px;
      min-height: 300px;
    }
    .plan-content {
      height: 250px;
    }
    .plan-info {
      padding: 30px 30px;
    }

    .plan-info-text {
      text-align: center;
    }
    .plan-info-title {
      text-align: center;
    }
    .plan-feek-text {
      font-size: 24px;
      margin-bottom: 20px;
    }

    .plan-feek-image {
      max-width: 250px;
    }
  }
`;

/**
 * FeekPlan component - displays the plan creation section with background image
 * Shows the call-to-action for creating perfect plans with Feek
 */
export const FeekPlan = () => {
  return (
    <div id="plan-feek" css={styles}>
      <div className="row w-100 row-plan-info">
        <div className="col-xl-7 col-lg-7 plan-info">
          <Text
            color={WHITE}
            className="plan-info-title mb-5"
            fontSize={42}
          >
            <b>¡Con Feek arma tu plan perfecto!</b>{' '}
          </Text>

          <Text
            color={WHITE}
            className="plan-info-text mb-5"
            fontSize={34}
          >
            Tu nos dices de que traes antojo y nosotros te armamos el
            plan.
          </Text>
        </div>
        <div className="col-xl-5 col-lg-5 d-flex justify-content-center align-items-center plan-content">
          {/* Background image applied via CSS */}
        </div>
      </div>
    </div>
  );
};
